import React from 'react';
import { Article } from '../../components';
import { blog01, blog02, blog03, blog04, blog05 } from './imports';
import './blog.css';

const Blog = () => (
  <div className="gpt3__blog section__padding" id="blog">
    <div className="gpt3__blog-heading">
      <h1 className="gradient__text">A lot is happening, <br /> & we are writing about it.</h1>
    </div>
    <div className="gpt3__blog-container">
    {/* 'groupA' will be the left side of the page */}
      <div className="gpt3__blog-container_groupA">
        <Article imgUrl={blog01} date="Sep 2, 2021" title="Learning to summarize from human feedback" />
      </div>
      <div className="gpt3__blog-container_groupB">
        <Article imgUrl={blog02} date="Sep 7, 2021" title="Generative Language Modeling" />
        <Article imgUrl={blog03} date="May 8, 2021" title="Measuring the Algorithmic Efficiency" />
        <Article imgUrl={blog04} date="Apr 15, 2021" title="Trustworthy AI Development" />
        <Article imgUrl={blog05} date="Feb 20, 2021" title="Preparing for Malicious AI" />
      </div>
    </div>
  </div>
);

export default Blog;